import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import styles from "./CustomMonthPicker.module.css";

const CustomMonthPicker = ({
  label,
  name,
  value,
  defaultValue,
  onChange,
  onBlur,
  placeholder = "Select month",
  disabled = false,
  required = false,
  readOnly = false,
  error,
  helperText,
  className = "",
  inputClassName = "",
  labelClassName = "",
  minDate,
  maxDate,
  excludeMonths,
  includeMonths,
  isClearable = true,
  size = "sm",
  // size = 'md',
  ...rest
}) => {
  const sizeMap = {
    sm: "small",
    md: "medium",
    lg: "medium",
  };

  const getSxForSize = () => {
    if (size === "lg") {
      return {
        "& .MuiInputBase-input": {
          padding: "14px 16px",
          fontSize: "1.1rem",
        },
      };
    }
    if (size === "sm") {
      return {
        "& .MuiInputBase-input": {
          padding: "8px 12px",
          fontSize: "0.875rem",
        },
      };
    }
    return {};
  };

  const shouldDisableMonth = (date) => {
    if (!date) return false;

    const month = date.month();
    const year = date.year();

    if (excludeMonths) {
      return excludeMonths.some(
        (excludeDate) =>
          month === excludeDate.month() && year === excludeDate.year()
      );
    }

    if (includeMonths) {
      return !includeMonths.some(
        (includeDate) =>
          month === includeDate.month() && year === includeDate.year()
      );
    }

    return false;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className={`${styles.monthPickerWrapper} ${className}`}>
        {label && (
          <label
            htmlFor={name}
            className={`${styles.label} ${labelClassName} ${
              disabled ? styles.labelDisabled : ""
            }`}
          >
            {label}
            {required && <span className={styles.required}>*</span>}
          </label>
        )}

        <DatePicker
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          disabled={disabled}
          readOnly={readOnly}
          minDate={minDate}
          maxDate={maxDate}
          views={["year", "month"]}
          openTo="month"
          shouldDisableMonth={
            excludeMonths || includeMonths ? shouldDisableMonth : undefined
          }
          slotProps={{
            textField: {
              id: name,
              name: name,
              fullWidth: true,
              size: sizeMap[size],
              error: !!error,
              helperText: error || helperText,
              placeholder: placeholder,
              onBlur: onBlur,
              className: inputClassName,
              sx: {
                ...getSxForSize(),
                "& .MuiOutlinedInput-root": {
                  borderRadius: "6px",
                },
                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "#ef4444",
                  },
                "& .MuiFormHelperText-root.Mui-error": {
                  color: "#ef4444",
                },
              },
            },
            field: {
              clearable: isClearable && !disabled && !readOnly,
            },
            actionBar: {
              actions: isClearable ? ["clear", "accept"] : ["accept"],
            },
          }}
          {...rest}
        />
      </div>
    </LocalizationProvider>
  );
};

export default CustomMonthPicker;
